import { watch } from 'vue';

/**
 * Watches a value and invokes a callback when it becomes false.
 *
 * @param {import('vue').Ref<boolean>} source - The value to watch.
 * @param {()=>void} cb - The callback function to invoke when the value changes.
 * @param {import('vue').WatchOptions} [options] - Additional options for watching.
 *
 * @returns {import('vue').WatchStopHandle} - A function to stop watching the value.
 */
export function watchFalse(source, cb, options) {
  return watch(
    source,
    () => {
      if (!source.value) {
        cb();
      }
    },
    {
      ...options,
      immediate: true,
    },
  );
}
